var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button_switch_panel-container px-0 py-2 mb-0"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }